import * as Sentry from '@sentry/browser';
import calendar from './calendar';

// Error logging
if (window.location.hostname !== 'localhost' && window.location.hostname !== 'globe.test' && window.WP_CONFIG && window.WP_CONFIG.SENTRY_DSN) {
    Sentry.init({
        dsn: window.WP_CONFIG.SENTRY_DSN
    });
}

require('./aria.accordion.min.js')

require('lazysizes')
// require('./lazysizes.respimg.js')
require('./slick-carousels.js')

const Parallax = require('parallax-js')
const SmoothScroll = require('./smoothscroll')
const TweenMax = require('./TweenMax')
require('./van11y-accessible-simple-tooltip-aria.es6')
require('./waypoint')

require('./masthead')
require('./whats-on-filters-sticky')
require('./gallery')

jQuery(function($) {

    require('./dialogs')

    // Variable set up

    const $html = $('body');
    let docHeight = $(document).height();
    let winHeight = $(window).height();
    const winWidth = $(window).width();
    const headerHeight = $('.c-closed-header').height();
    const mastheadHeight = $('.c-masthead').height() || 100;
    const $mark = $('.c-head-roundel-wrap');
    const $markSpin = $('.c-head-roundel');
    const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;


    let scrollPos;
    let headShown = false;
    let footReached = false;


    // requestanimationframe throttle
    (function() {
        const throttle = function(type, name, obj) {
            const lclObj = obj || window;
            let running = false;
            const func = function() {
                if (running) {
                    return;
                }
                running = true;
                requestAnimationFrame(function() {
                    lclObj.dispatchEvent(new CustomEvent(name));
                    running = false;
                });
            };
            lclObj.addEventListener(type, func);
        };
        throttle('scroll', 'optimizedScroll');
    })();


    window.addEventListener('optimizedScroll', function () {

        scrollPos = window.pageYOffset;
        docHeight = $(document).height();
        winHeight = $(window).height();

        const scrollPercent = Math.floor((scrollPos / (docHeight - winHeight)) * 100);

        // at reduced motion, keeping the shrink header as it's a functional animation,
        // but removing the spinning roundel as it's aesthethic
        if (!isReducedMotion) {
            // spins rounedel on scroll - again throttled with setTimout
            window.setTimeout(function () {
                TweenMax.to($markSpin, 0.1, {
                    ease: TweenMax.Power1.easeOut,
                    rotation: scrollPercent,
                });
            }, 100);
        }
        
        scrollClassSetup();

    }); // end scroll listener



    function scrollClassSetup() {
        //adds at bottom class when at page bottom to do animations
        if (winWidth > 1000) {
            if ( scrollPos == (docHeight - winHeight) ) {
                if(!headShown){
                    $html.addClass('state--at-bottom');
                    // at reduced motion, keep the fade in for footer elements, lose the roundel effect
                    if (!isReducedMotion) {
                        TweenMax.to($mark, 0.3, {
                            ease: TweenMax.Power1.easeOut,
                            scale: 3.5,
                            y: 50,
                            rotation: 50,
                        });
                    }
                }
            }
            if ( scrollPos < (docHeight - winHeight) ) {
                if(!headShown){
                    $html.removeClass('state--at-bottom');
                    if (!isReducedMotion) {
                        TweenMax.to($mark, 0.3, {
                            ease: TweenMax.Power1.easeOut,
                            scale: 1,
                            y: 0,
                            rotation: -50,
                        });
                    }
                }
            }

            if ( (scrollPos + winHeight) > (docHeight - winHeight) ) {
                $html.addClass('state--footer-reached');
                footReached = true;
            }

            if ( (scrollPos + winHeight) < (docHeight - winHeight) && footReached === true ) {
                $html.removeClass('state--footer-reached');
                footReached = false;
            }
        }

        if(!$html.hasClass('header--unfixed')) {
            // toggles has lef top classes when left top
            if (scrollPos > mastheadHeight) {
                $html.addClass('state--has-left-top');
                $html.removeClass('state--at-top');
            } else {
                $html.addClass('state--at-top');
                $html.removeClass('state--has-left-top');
            }
        }
    }

    scrollClassSetup(); // fire once when page loads

    // Smoothscroll anchors

    // eslint-disable-next-line no-unused-vars
    const scroll = new SmoothScroll('a[data-scroll]', { offset: headerHeight + 40 });

    (function(hash) {
        const $target = jQuery(hash);
        if ($target.length) {
            jQuery('html, body').stop().animate(
                {'scrollTop': $target.offset().top - headerHeight}, 0
            );
        }
    })(window.location.hash);

    // add active class to buttons with has-spinner class

    $('.c-btn--has-spinner').click(function() {
        $(this).toggleClass('active');
    });


    let firstElement;
    let lastElement;

    const KEY_TAB = 'Tab';
        
    /*
    * Config for the focus trap
    * @param {array} parents - an array of elements to which the focus should be constrained
    * @param {HTMLElement} elementToFocus - an element to focus when the trap is activated.
    * Focus trap will be removed from the parent when no elementToFocus is passed
    */
    function trapFocus(parents, elementToFocus) {
        // If no elementToFocus is passed, remove all event listeners and get out of here
        if(!elementToFocus) {
            // Trap off. Remove event listeners
            window.removeEventListener("keydown", handleTrapKeydown);
            return;
        }

        let elements = [];
        // Otherwise find all focusable elements inside the parent element passed to this function
        Array.from(parents).forEach(item => {
            elements.push(...getFocusableElements(item));
        });

        firstElement = elements[0];
        lastElement = elements[elements.length - 1];
        // Trap on
        elementToFocus.focus();
        window.addEventListener("keydown", handleTrapKeydown);
    }

    /* 
    * Get focusable elements inside a wrapper
    * @param {HTMLElement} element - the wrapper element to be searched through for focusable items
    * @returns {array} focusable
    */
    function getFocusableElements(element) {
        let focusable = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');        
        // Filter to remove elements that are visually hidden with css
        focusable = Array.from(focusable).filter(item => {
            const computedStyle = window.getComputedStyle(item);
            return computedStyle.display !== "none" && computedStyle.visibility !== "hidden";
        });
        return focusable;   
    }


    /* 
    * Keydown event handler for the focus trap
    * Checking which key was pressed, handling looping, etc.
    */
    function handleTrapKeydown(e) {
        const isTabPressed = (e.key === KEY_TAB);
        if (!isTabPressed) {
            return;
        }
        if (e.shiftKey) {
            if (document.activeElement === firstElement) {
                lastElement.focus();
                e.preventDefault();
            }
        } else {
            if (document.activeElement === lastElement) {
                firstElement.focus();
                e.preventDefault();
            }
        }
    }


    // It's header time
    const mainMenuToggle = document.querySelector('.js-main-menu-toggle');
    const headerFocusableWrappers = document.querySelectorAll('.js-trap-focus');

    let savedScrollPos;

    $('#head-toggle').click(function(e) {
        e.preventDefault();
        if (headShown) {
            removeHead();
        } else {
            showHead();
        }
        headShown = !headShown;
    });

    function showHead() {
        savedScrollPos = window.pageYOffset;
        $html.toggleClass('state--head-open state--head-closed');
        $('.c-open-header').toggleClass('u-hidden-visually');
        trapFocus(headerFocusableWrappers, mainMenuToggle);
        if (winWidth > 1000) {
            if (!isReducedMotion) {
                TweenMax.to($mark, 0.3, {
                    ease: Back.easeIn,
                    scale: 2.5,
                    y: 50,
                    rotation: 50,
                });
            }
        }
    }

    function removeHead() {
        $html.toggleClass('state--head-open state--head-closed');
        $('.c-open-header').toggleClass('u-hidden-visually');
        window.scrollTo(0, savedScrollPos);
        trapFocus(headerFocusableWrappers, null);
        if (winWidth > 1000) {
            if (!isReducedMotion) {
                TweenMax.to($mark, 0.3, {
                    ease: Back.easeIn,
                    scale: 1,
                    y: -1,
                    rotation: -50,
                });
            }
        }
    }

    // Esc closes header menu
    const KEYCODE_ESC = 27;
    $(document).keyup(function(e) {
        if (e.keyCode == KEYCODE_ESC) {
            if (headShown) {
                removeHead();
                headShown = !headShown;
            }
        }
    });



    // navigation hovers crossfade switch of nav backgrounds
    // mouseenter

    if (!isReducedMotion && winWidth > 1000) {

        $('.js-nav-bg-change').mouseenter(function () {
            const imageId = $(this).attr('data-panel');
            const $panel = $(".layer[data-panel='" + imageId + "']");
            let panelBg = $panel.attr('data-panel-bg');
            panelBg = "url('" + panelBg + "')";
            if (panelBg) {
                $('.c-open-header-part__foreground .layer').removeClass('active');
                $panel.addClass('active');
                $panel.css('background-image', panelBg);
            }
        });
        // mouseleave
        $('.js-nav-bg-change').mouseleave(function () {
            $('.c-open-header-part__foreground .layer').removeClass('active');
            $panel.addClass('active').css('background-image', `url('${panelBg}')`);
        })
    };
    
    const clearNavBg = () => {
        $('.c-open-header-part__foreground .layer').removeClass('active');
    };
    
    if (winWidth > 1000) {
        $('.js-nav-bg-change')
            .on('mouseenter', function () { updateNavBg($(this).attr('data-panel')); })
            .on('mouseleave', clearNavBg);
    }
    
    // Keyboard: not gated on winWidth
    $('.js-nav-bg-change')
        .on('focusin', function () { updateNavBg($(this).attr('data-panel')); })
        .on('focusout', clearNavBg);


    let loaderTimeoutId = 0
    const showLoaderSingleton = function() {
        clearTimeout(loaderTimeoutId)
        loaderTimeoutId = setTimeout(function() {
            $html.toggleClass('has-navigated');
        }, 350)
    }
    // open header
    $('.c-open-header a').click(function() {
        showLoaderSingleton()
        $('#head-toggle').trigger('click');
    });
    // add class to collapse menu after link clicked
    $('.c-closed-nav a').not('.c-global-head__toggle').click(function(e) {
        showLoaderSingleton()
    });

    // Toggle submenus in main nav
    $('.c-open-nav-list-item__sublink-toggle').click(function() {
        const $button = $(this);
        const $listItem = $button.parent().parent();
        const isExpanded = $button.attr('aria-expanded') === 'true';
        
        // Close all other menus
        $('.c-open-nav-list-item').not($listItem).removeClass('active')
            .find('.c-open-nav-list-item__sublink-toggle').attr('aria-expanded', 'false');
        $('.c-open-nav-list-item__sublinks').not($listItem.find('.c-open-nav-list-item__sublinks')).attr('hidden', '');
        
        // Toggle current menu
        $listItem.toggleClass('active');
        $button.attr('aria-expanded', !isExpanded);
        $listItem.find('.c-open-nav-list-item__sublinks').prop('hidden', isExpanded);
    });

    if (winWidth > 1000) {

        //subdue other anchor list links on hover
        $('.c-anchor-list a').hover(function() {
            $('.c-anchor-list a').not(this).toggleClass('not-active');
        });

        //subdue other closed nav links on hover
        $('.c-closed-nav a').hover(function() {
            $('.c-closed-nav a').not(this).toggleClass('not-active');
        });

        // subdue other open nav links on hover
        $('.c-open-header-part--rhs .c-open-nav-list-item--top-level').hover(function(){
            $('.c-open-header-part--lhs .c-open-nav-list-item').toggleClass('not-active');
            $('.c-open-header-part--rhs .c-open-nav-list-item--top-level').not(this).toggleClass('not-active');
        });
        $('.c-open-header-part--lhs .c-open-nav-list-item').hover(function(){
            $('.c-open-header-part--rhs .c-open-nav-list-item').toggleClass('not-active');
            $('.c-open-header-part--lhs .c-open-nav-list-item').not(this).toggleClass('not-active');
        });
        $('.c-footer-nav a').hover(function(){
            $('.c-footer-nav a').not(this).toggleClass('not-active');
        });
        $('.c-social-nav a').hover(function(){
            $('.c-social-nav a').not(this).toggleClass('not-active');
        });

    }

      // Event filters
    $('.c-event-filters__mobile-toggle, .c-event-filters__mobile-submit').click(function() {
        $('.c-event-filters__wrap').toggleClass('active');
    });

    // Blog filters
    $('.global-filters__mobile-toggle').click(function () {
        $('.global-filters-wrap--mobile').toggleClass('active');
    });


    // faq toggling

    $(".c-faq-item__q").click(function() {
        $(this)
            .next()
            .toggleClass("u-hidden-visually");
        $(this)
            .parent()
            .toggleClass("faq-open");
    });

    // Mouse tracaked parallax for masthead layers
    if (!isReducedMotion && $('#c-masthead-layers').length) {
        const mastheadLayers = document.getElementById('c-masthead-layers');
        // eslint-disable-next-line no-unused-vars
        const plax = new Parallax(mastheadLayers);
    }

    /**
     * Sets up the transition of the content that fades in on scroll.
     * Set as global function to allow the it to be called after the AJAX
     * call for the membership content is loaded.
     */
    window.setupTransitions = function() {
        // Add waypoint triggered animation class to the c-animate-in construkt blocks
        let osAnimationClass;
        const $animateBlocks = $('.c-animate-in');

        $animateBlocks.waypoint(
            function(direction) {
                if (direction === 'down') {
                    this.element.classList.remove('fadeOutDown');
                    osAnimationClass = this.element.getAttribute('data-os-animation');
                    this.element.classList.add(osAnimationClass);
                    this.element.classList.add('animation-done');
                }
            },
            {
                offset: '75%',
            },
        );
        $animateBlocks.waypoint(
            function(direction) {
                if (direction === 'up') {
                    osAnimationClass = this.element.getAttribute('data-os-animation');
                    this.element.classList.remove(osAnimationClass);
                    this.element.classList.add('fadeOutDown');
                    this.element.classList.remove('animation-done');
                }
            },
            {
                offset: '90%',
            },
        );

        // An object with options for the IntersectionObserver.
        const options = {
            // 0.5 = The callback is fired when 50% of the element is visible
            // We can add more values to the array, like 0.25, 0.75 or 1.0
            threshold: [0.5]
        };

        // Instantiate the IntersectionObserver class
        const observer = new IntersectionObserver((entries, observer) => {
            // This is the callback.
            entries.forEach((entry => {
                // Checks if 50% or more of the element is visible in the viewport
                if (entry.intersectionRatio >= 0.5) {
                    // Call the setCurrent function and pass the element (DOM-node)
                    setCurrent(entry.target);
                    return;
                }
            }));
            // End of callback. Pass the options object as the second argument.
        }, options);

        const setCurrent = (section) => {
            // Finds all elements (<a> and <section>) with the .current class and remove it.
            document.querySelectorAll('.in-view').forEach((el) => el.classList.remove('in-view'));

            // Add the .current class to the current <section>...
            section.classList.add('in-view');
            // ...and the current <a> in the navbar.
            // adding class only if section is present
            if(section.id !== undefined && section.id.trim.length > 0) {
                document.querySelector(`.c-anchor-list a[href="#${section.id}"]`).classList.add('in-view');
            }
        };

        // Query the DOM for all the sections...
        const sections = document.querySelectorAll('.c-page__body .c-container');
        // Loop through them and tell our instance of the
        // IntersectionObserver class to observe each one of them.
        sections.forEach((section) => observer.observe(section));
    }
    window.setupTransitions();

    // Full Calendar renderer
    const fullCalendarElement = document.getElementById('fullcalendar')

    if (fullCalendarElement && window.fullCalendarInstances) {
        const fullCalendar = calendar(fullCalendarElement)

        fullCalendar.render()
    }

    //
    // DesignMyNight widget https://developers.designmynight.com/collins/booking-widget/
    //
    $('div .booking-form').parents('.c-container').attr('id', 'make-a-reservation');

    if ($('#make-a-reservation').length > 0) {
        // Replace text in heading and buttons
        $(".booking-form .dmn-form h1.ng-binding").text('DINE WITH SWAN BAR & RESTAURANT'); //h1
        $(".booking-form .btn-primary.submit").text('Find a table'); //button

        // Set default values
        var formId = document.getElementById('make-a-reservation').getElementsByClassName('dmn-form')[0].getAttribute('id').substr('dmn-form-'.length);
        DMN.val({ field: 'type', value: 'Restaurant Dinner', formId: formId });
        DMN.val({ field: 'numPeople', value: 2, formId: formId });

        // Add "Select" option and set it as default
        //date field
        $(".booking-form .dmn-date-container #dmn-date").attr('placeholder', 'Select');

        //time field
        // jquerify the DOM object 'select' so we can use the html method
        var select = new Option("value");
        $(select).html("Select");
        $(".booking-form .dmn-time-container #dmn-time").append(select);
        // Set default value "Time"
        $('.booking-form .dmn-time-container select option:contains("Select")').prop('selected', true);
    }

});

// Membership access to pages and posts
require('./memberships')
// Promo code tracking
require('./promo.js')
// Gravity Forms Query String Field Population
require('./gravity-forms-query-string-field-population.js')



// WEBPACK FOOTER //
// ./src/js/main.js